<!-- 由 suu 创建于 2025-03-04 星期二 -->
<template>
  <div class="DetailTipsPop" @click.stop>
    <!-- 首次预约非主责教练提醒 -->
    <template v-if="showTipsPopType == 29999">
      <div class="pop-title">首次约课训练提醒</div>
      <div class="pop-sub"
        >因该教练首次为您提供训练服务，为了避免强度过高产生不适，<span
          >课程将以低强度适应性训练开始；</span
        ></div
      >
      <img
        class="pop-br"
        src="https://cdnvue.gymcity.com.cn/uploads/appo-coach-first-br"
        alt=""
      />
      <div class="pop-cent pop-cent-first"
        >您可以在训练过程中实时反馈您的训练感受，教练会动态调整训练强度。
        <br />您是否同意?</div
      >
      <div class="pop-btn user-btn" @click.stop="handleConfirm">同意</div>
      <div class="pop-btn-off user-btn" @click.stop="handleCancel">再想想</div>
    </template>
    <!-- 停卡中提醒 -->
    <template v-else-if="showTipsPopType == 10111">
      <div class="pop-title">当前处于停卡期间内</div>
      <div class="pop-cent"
        >您无法预约停卡期间内的课程哦，需要激活会员卡后才能继续预约</div
      >
      <div class="pop-btn user-btn" @click.stop="handleConfirm">去激活</div>
      <div class="pop-btn-off user-btn" @click.stop="handleCancel">关闭</div>
    </template>
    <!-- 特殊停卡中提醒 -->
    <template v-else-if="showTipsPopType == 10112">
      <div class="pop-title">当前处于停卡期间内</div>
      <div class="pop-cent"
        >您无法预约停卡期间内的课程哦，请联系店长或者教练解除特殊停卡</div
      >
      <div class="pop-btn user-btn" @click.stop="handleCancel">我知道了</div>
    </template>
    <!-- 预停卡提醒 -->
    <template v-else-if="showTipsPopType == 10113">
      <div class="pop-title">您已设置预停卡</div>
      <div class="pop-cent"
        >当前课程时间在您预停卡期间内，需取消预停卡后才能继续预约。特殊停卡请联系店长或教练取消</div
      >
      <div class="pop-btn user-btn" @click.stop="handleConfirm"
        >去取消预停卡</div
      >
      <div class="pop-btn-off user-btn" @click.stop="handleCancel">关闭</div>
    </template>
    <!-- 未激活会员卡提醒 -->
    <template v-else-if="showTipsPopType == 10020">
      <div class="pop-title">提示</div>
      <div class="pop-cent"
        >您还没有激活会员卡，无法预约课程，请进行卡激活操作</div
      >
      <div class="pop-btn user-btn" @click.stop="handleConfirm">去激活</div>
      <div class="pop-btn-off user-btn" @click.stop="handleCancel">关闭</div>
    </template>
    <!-- 课程超出当前卡范围 有下张卡 提示预激活 -->
    <template v-else-if="showTipsPopType == 10114">
      <div class="pop-title">提示</div>
      <div class="pop-cent">{{ showTipsPopMsg }}</div>
      <div class="pop-btn user-btn" @click.stop="handleConfirm">去预激活</div>
      <div class="pop-btn-off user-btn" @click.stop="handleCancel">关闭</div>
    </template>
    <!-- 课程超出当前卡范围 没有下张卡 提示续卡 -->
    <template v-else-if="showTipsPopType == 10115">
      <div class="pop-title">提示</div>
      <div class="pop-cent">{{ showTipsPopMsg }}</div>
      <div class="pop-btn user-btn" @click.stop="handleConfirm">立即续卡</div>
      <div class="pop-btn-off user-btn" @click.stop="handleCancel">关闭</div>
    </template>
    <!-- 课程超早于预激活 -->
    <template v-else-if="showTipsPopType == 10118">
      <div class="pop-title">提示</div>
      <div class="pop-cent">{{ showTipsPopMsg }}</div>
      <div class="pop-btn user-btn" @click.stop="handleConfirm">去调整</div>
      <div class="pop-btn-off user-btn" @click.stop="handleCancel">关闭</div>
    </template>
    <!-- 没有任何卡 -->
    <template v-else-if="showTipsPopType == 10119">
      <div class="pop-title">提示</div>
      <div class="pop-cent">{{ showTipsPopMsg }}</div>
      <div class="pop-btn user-btn" @click.stop="handleConfirm">去购卡</div>
      <div class="pop-btn-off user-btn" @click.stop="handleCancel">关闭</div>
    </template>
    <!-- 未实名 门店约课权限提醒 -->
    <template v-else-if="showTipsPopType == 1031">
      <div class="pop-title">预约失败</div>
      <div class="pop-cent"
        >您暂无该门店约课权限，请前往实名认证，开启多门店约课权限</div
      >
      <div class="pop-btn user-btn" @click.stop="handleConfirm"
        >前往实名认证</div
      >
      <div class="pop-btn-off user-btn" @click.stop="handleCancel">关闭</div>
    </template>
    <!-- 您当前会员等级的约课节数已满，无法继续预约了，点击了解会员等级约课权益 -->
    <template v-else-if="showTipsPopType == 1104">
      <div class="pop-title">提示</div>
      <div class="pop-cent">{{ showTipsPopMsg }}</div>
      <div class="pop-btn user-btn" @click.stop="handleConfirm"
        >了解约课权益</div
      >
      <div class="pop-btn-off user-btn" @click.stop="handleCancel">关闭</div>
    </template>
    <!-- 其他提醒 -->
    <template v-else>
      <div class="pop-title">提示</div>
      <div class="pop-cent">{{ showTipsPopMsg }}</div>
      <div class="pop-btn user-btn" @click.stop="handleCancel">我知道了</div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'DetailTipsPop',

  components: {},

  props: {
    showTipsPopType: {},
    showTipsPopMsg: {}
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    handleConfirm() {
      this.$emit('confirm')
    },
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.DetailTipsPop {
  position: fixed;
  z-index: 21;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -55%);
  width: vw(275);
  box-sizing: border-box;
  padding: 0 vw(24);
  padding-bottom: vw(24);
  background: #ffffff;
  border-radius: vw(8);
  display: flex;
  flex-direction: column;
  align-items: center;
  .pop-title {
    font-weight: 600;
    font-size: vw(18);
    color: #050b27;
    margin-top: vw(32);
    line-height: vw(25);
  }
  .pop-sub {
    font-weight: 300;
    font-size: vw(13);
    line-height: vw(20);
    color: rgba($color: #050b27, $alpha: 0.8);
    margin-top: vw(7);
    text-align: center;
    span {
      color: #dc0050;
      font-weight: 500;
    }
  }
  .pop-cent {
    font-weight: 300;
    font-size: vw(13);
    color: rgba($color: #050b27, $alpha: 0.8);
    margin-top: vw(7);
    text-align: center;
    line-height: vw(20);
    word-break: break-all;
  }
  .pop-br {
    width: vw(235);
    min-height: vw(16);
    margin-top: vw(10);
  }
  .pop-cent-first {
    margin-top: vw(10);
    font-weight: 500;
    color: #050b27;
  }
  .pop-btn {
    width: 100%;
    height: vw(40);
    box-sizing: border-box;
    background: #ff2270;
    box-shadow: 0px vw(1) vw(1) 0px rgba(0, 0, 0, 0.1);
    border-radius: 99px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: vw(14);
    color: #ffffff;
    margin-top: vw(20);
  }
  .pop-btn-off {
    background-color: transparent;
    color: #050b27;
    font-size: vw(12);
    margin-top: vw(20);
  }
}
</style>
